'use client'

import { AuthGateModal } from '@/components/auth/AuthGateModal'

const LOGIN_HREF = '/login?next=/settings'
const SIGNUP_HREF = '/signup?next=/settings'

/**
 * Sign-in / sign-up gate for the Settings page. Logged-out visitors can
 * browse the full channel catalog, but selecting a channel to connect it
 * opens this modal instead of the connection panel.
 */
export function SettingsAuthGateModal({
  open,
  channelName,
  channelAccentHex,
  onClose,
}: {
  open: boolean
  channelName: string | null
  channelAccentHex: string | null
  onClose: () => void
}) {
  return (
    <AuthGateModal
      open={open}
      onClose={onClose}
      title={`Sign in to connect${channelName ? ` ${channelName}` : ''}`}
      body="Browse every channel freely. Create an account or sign in to connect channels, set budgets, and launch campaigns."
      accent={channelAccentHex || 'var(--color-brand)'}
      loginHref={LOGIN_HREF}
      signupHref={SIGNUP_HREF}
      bodyId="settings-gate-body"
    />
  )
}
